export default "__VITE_ASSET__Bq5Ytb1B__"